module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/add-icon-8041252a3ef2eb0b87853a8e667c7ab2.png";